import { render, staticRenderFns } from "./TachographVehicleDriverCardMovement.vue?vue&type=template&id=0fd67c48&"
import script from "./TachographVehicleDriverCardMovement.vue?vue&type=script&lang=js&"
export * from "./TachographVehicleDriverCardMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports